import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const LifestyleSection = ({ commune }) => {
  if (!commune) return null;

  const lifestyleCategories = [
  {
    id: 'dining',
    title: 'Restaurants & Cafés',
    icon: 'UtensilsCrossed',
    items: commune?.lifestyle?.dining,
    color: 'bg-orange-50 text-orange-600'
  },
  {
    id: 'shopping',
    title: 'Shopping',
    icon: 'ShoppingBag',
    items: commune?.lifestyle?.shopping,
    color: 'bg-purple-50 text-purple-600'
  },
  {
    id: 'entertainment',
    title: 'Divertissement',
    icon: 'Music',
    items: commune?.lifestyle?.entertainment,
    color: 'bg-blue-50 text-blue-600'
  },
  {
    id: 'sports',
    title: 'Sports & Loisirs',
    icon: 'Dumbbell',
    items: commune?.lifestyle?.sports,
    color: 'bg-green-50 text-green-600'
  }];


  return (
    <div className="bg-surface border-none">
      <div className="max-w-7xl mx-auto px-4 lg:px-6 py-16 border-none">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center space-x-2 mb-4">
            <Icon name="Heart" size={20} className="text-brand-gold" />
            <span className="text-sm font-medium text-brand-gold uppercase tracking-wide">
              Art de Vivre
            </span>
          </div>
          
          <h2 className="text-3xl lg:text-4xl font-heading font-bold text-text-primary mb-4">
            Vivre à {commune?.name}
          </h2>
          
          <p className="text-lg text-text-secondary max-w-3xl mx-auto">
            Découvrez les lieux emblématiques, les activités et l'ambiance unique qui font le charme de cette commune
          </p>
        </div>

        {/* Lifestyle Categories */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {lifestyleCategories?.map((category) =>
          <div key={category?.id} className="bg-white rounded-xl p-6 shadow-warm hover:shadow-deep transition-shadow duration-300 border-none">
              <div className={`inline-flex p-3 rounded-lg ${category?.color} mb-4`}>
                <Icon name={category?.icon} size={24} />
              </div>
              
              <h3 className="font-heading font-semibold text-text-primary mb-4">
                {category?.title}
              </h3>
              
              <div className="space-y-3">
                {category?.items?.map((item, index) =>
              <div key={index} className="flex items-start space-x-3">
                    <Icon name="MapPin" size={14} className="text-text-secondary mt-1 flex-shrink-0" />
                    <div>
                      <p className="font-medium text-text-primary text-sm">{item?.name}</p>
                      <p className="text-xs text-text-secondary">{item?.description}</p>
                    </div>
                  </div>
              )}
              </div>
            </div>
          )}
        </div>

        {/* Daily Life Gallery */}
        <div className="bg-white rounded-2xl p-8 shadow-warm border-none">
          <div className="flex items-center justify-between mb-8">
            <div>
              <h3 className="text-2xl font-heading font-bold text-text-primary mb-2">
                La Vie Quotidienne
              </h3>
              <p className="text-text-secondary">
                Immergez-vous dans l'atmosphère authentique du quartier
              </p>
            </div>
            
            <button className="flex items-center space-x-2 px-4 py-2 bg-brand-gold text-white rounded-lg hover:bg-brand-earth transition-colors duration-300">
              <Icon name="Play" size={16} />
              <span className="text-sm font-medium">Voir Tout</span>
            </button>
          </div>
          
          <div className="grid md:grid-cols-3 gap-6">
            {commune?.dailyLifeImages?.map((image, index) =>
            <div key={index} className="relative group cursor-pointer">
                <div className="relative h-48 rounded-xl overflow-hidden">
                  <Image
                  src={image?.url}
                  alt={image?.caption}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />

                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                  
                  <div className="absolute bottom-4 left-4 right-4 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <p className="font-medium text-sm">{image?.caption}</p>
                    <p className="text-xs opacity-80">{image?.location}</p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>);

};

export default LifestyleSection;